import React, { useState, useEffect } from "react";
import {
  Modal,
  Backdrop,
  Fade,
  TextField,
  FormControl,
  Button,
  IconButton,
  Typography,
  Box,
  Select,
  MenuItem,
  InputLabel,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import ErrorIcon from "@mui/icons-material/Error";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { withStyles } from "@material-ui/core";
import CircularProgress from "@mui/material/CircularProgress";
import { useDispatch, useSelector } from "react-redux";
import { sendotp, verifyotp, verify_fr } from "../../actions/auth.action";
import crowdSourceService from "services/crowdService";
import { otpSelector, userSelector } from "../../selectors/auth.selector";

import crowdService from "services/crowdService";
import toast from "react-hot-toast";

import {
  loadFaceCaptureScripts,
  captureFace,
} from "customhooks/useFaceCapture";

// TypeScript fix for external window function
declare global {
  interface Window {
    jukshioFaceCapture?: (
      params: any,
      callback: (response: any) => void,
    ) => void;
  }
}

interface AddDeviceModalProps {
  open: boolean;
  onClose: () => void;
  selectedTransaction?: any;
  selectedRows?: any[];
  setIsBatchPayments: (value: boolean) => void;
  isBatchPyaments: boolean;
  start_date: string;
  end_date: string;
  reloadData: () => void;
  isWithdrawRequests?: boolean;
  selectAllForBatchPayments?: string;
  isItFromHistorySection?: boolean;
  deSelectedTransactionHisotryIds?: string[];
  deSelectedUsersList?: string[];
}

const theme = createTheme({
  typography: {
    fontFamily: ['"Lexend"', "sans-serif"].join(","),
  },
});

const CustomTextField = withStyles({
  root: {
    "& .MuiInputBase-root.MuiOutlinedInput-root": {
      borderRadius: "10px",
    },
  },
})(TextField);

const AddDeviceModal: React.FC<AddDeviceModalProps> = ({
  open,
  onClose,
  selectedRows,
  selectedTransaction,
  setIsBatchPayments,
  isBatchPyaments,
  start_date,
  end_date,
  reloadData,
  isWithdrawRequests = false,
  selectAllForBatchPayments = "",
  isItFromHistorySection = false,
  deSelectedTransactionHisotryIds = [],
  deSelectedUsersList = [],
}) => {
  const [remarks, setRemarks] = useState("");
  const [currentStep, setCurrentStep] = useState<
    "otp" | "verify-otp" | "face-recognition" | "success"
  >("otp");
  // const [currentStep, setCurrentStep] = useState<'otp' | 'verify-otp' | 'face-recognition' | 'success'>('face-recognition');
  const [otp, setOtp] = useState("");
  const [selectedOption, setSelectedOption] = useState("");
  const [transfterModeOptions, setTransferModeOptions] = useState([]);
  const [isOtpSent, setIsOtpSent] = useState(false);
  const dispatch = useDispatch();
  const userinfo = useSelector(userSelector);
  const entityid = userinfo?.currentuserinfo?.entity_id?.id;
  const otpinfo = useSelector(otpSelector);
  const [sendOtpToken, setSendOtpToken] = useState("");
  const [verifyOtpToken, setVerifyOtpToken] = useState("");
  const [frError, setFrError] = useState("");
  const [otpErrorMsg, setOtpErrorMsg] = useState("");
  const [frLoading, setFrLoading] = useState(false);
  const [paymentLoading, setPaymentLoading] = useState(false);
  const [paymentResult, setPaymentResult] = useState<{
    success: boolean;
    message: string;
  } | null>(null);

  // Load external scripts for face recognition
  useEffect(() => {
    if (open) {
      loadFaceCaptureScripts();
    }
  }, [open]);

  // Auto-send OTP when modal opens
  useEffect(() => {
    if (open && currentStep === "otp" && !isOtpSent) {
      handleSendOtp();
    }
  }, [open, currentStep, isOtpSent]);

  // Auto-send OTP when modal opens
  useEffect(() => {
    if (open && transfterModeOptions.length > 0) {
      const transfterObj: any = transfterModeOptions?.find(
        (each: any) => each?.value?.toLowerCase() === "neft",
      );
      if (transfterObj) {
        setSelectedOption(transfterObj?.value || "");
      }
    }
  }, [open, transfterModeOptions]);

  useEffect(() => {
    const fetchTransferModes = async () => {
      const entityId = userinfo?.currentuserinfo?.entity_id?.id;
      if (entityId) {
        const response: any = await crowdService.fetchTransferModes(entityId);
        if (!response?.error) {
          setTransferModeOptions(
            response?.data?.map((each: any) => ({
              value: each?.name,
              label: each?.name,
            })),
          );
        }
      }
    };
    fetchTransferModes();
  }, []);

  const handleSendOtp = async () => {
    const mobile = userinfo?.currentuserinfo?.phone_number;
    const entityId = userinfo?.currentuserinfo?.entity_id?.id;

    if (mobile && entityId) {
      const response: any = await crowdService.sendotp(mobile, entityId);
      if (response?.status === 200) {
        console.log("send otp token", response?.data?.auth_token);
        setSendOtpToken(response?.data?.auth_token);
        setIsOtpSent(true);
        setCurrentStep("verify-otp");
        toast.success(`OTP sent successfully to ${mobile} `);
      } else {
        toast.error(`Failed to send OTP ${mobile}`);
        console.error(`Failed to send OTP ${mobile}`);
      }
    }
  };

  const handleVerifyOtp = async () => {
    setOtpErrorMsg("");
    const mobile = userinfo?.currentuserinfo?.phone_number || "";
    const userId = userinfo?.currentuserinfo?.id || userinfo?.id || "";

    const type = "";
    const verifyResponse: any = await crowdService.verify_otp(
      otp,
      mobile,
      userId,
      sendOtpToken,
      type,
    );
    if (!verifyResponse?.error) {
      setVerifyOtpToken(verifyResponse?.auth_token);
      toast.success("OTP verified successfully");
      setCurrentStep("face-recognition");
      setOtpErrorMsg("");
    } else {
      setOtpErrorMsg("OTP verification failed");
      toast.error("OTP verification failed");
    }
  };

  const handleFaceCapture = async () => {
    const response: any = await captureFace();
    setFrLoading(true);
    setFrError("");
    const userId = userinfo?.currentuserinfo?.id || userinfo?.id || "";
    if (verifyOtpToken) {
      const resp: any = await crowdService.verify_fr(
        response?.image1,
        response?.image2,
        userId,
        verifyOtpToken,
      );

      if (!resp?.error) {
        toast.success("Face recognition verified successfully");
        setCurrentStep("success");
        setFrLoading(false);
        await onProceedInitiatePayments();
      } else {
        setFrError(resp?.error || "Face recognition verification failed");
        toast.error("Face recognition verification failed");
        setFrLoading(false);
      }
    }
  };

  const retryPayout = async () => {
    setPaymentLoading(true);
    setPaymentResult(null);
    try {
      const formData = {
        transaction_ids:
          selectedRows?.length || isBatchPyaments
            ? selectedRows?.map((each: any) => each?.transfer_id)
            : [selectedTransaction?.transfer_id],
        transfer_mode: selectedOption || "banktransfer",
        type: selectAllForBatchPayments || "",
        deselected_transaction_ids: deSelectedTransactionHisotryIds || [],
        remarks: remarks || "",
        entity_id: entityid || "",
        start_date: start_date || "",
        end_date: end_date || "",
      };

      // return console.log(formData, "actual form data===")
      const response = await crowdSourceService.retryInitiatingPayments(
        formData,
      );

      if (!response.error) {
        setPaymentResult({
          success: true,
          message: "Retry payout initiated successfully",
        });
        // Close all modals and reload data on success
        setTimeout(() => {
          reloadData();
          setIsBatchPayments(false);
          onClose();
        }, 2000);
      } else {
        setPaymentResult({
          success: false,
          message:
            response.message ||
            response.error ||
            "Retry payout initiation failed.",
        });
      }
    } catch (error: any) {
      setPaymentResult({
        success: false,
        message: error?.message || "Retry payout initiation failed",
      });
    } finally {
      setPaymentLoading(false);
    }
  };

  const makePayout = async () => {
    setPaymentLoading(true);
    setPaymentResult(null);
    try {
      const response = await crowdSourceService.initialPayout(
        selectedTransaction,
        entityid!,
        start_date,
        end_date,
        remarks || "",
        selectedOption || "",
        isWithdrawRequests || false,
      );

      if (!response.error) {
        setPaymentResult({
          success: true,
          message: "Payout initiated successfully",
        });
        // Close all modals and reload data on success
        setTimeout(() => {
          setIsBatchPayments(false);
          reloadData();
          onClose();
        }, 2000);
      } else {
        setPaymentResult({
          success: false,
          message:
            response.message || response.error || "Payout initiation failed.",
        });
      }
    } catch (error: any) {
      setPaymentResult({
        success: false,
        message: error?.message || "Payout initiation failed",
      });
    } finally {
      setPaymentLoading(false);
    }
  };

  const makeMultiplePayouts = async () => {
    setPaymentLoading(true);
    setPaymentResult(null);
    try {
      const response = await crowdSourceService.initiateMultiplePayouts(
        selectedRows?.length ? [...selectedRows] : [],
        entityid!,
        remarks || "",
        start_date,
        end_date,
        selectedOption || "",
        isWithdrawRequests || false,
        selectAllForBatchPayments || "",
        deSelectedUsersList || [],
      );

      if (!response.error) {
        setPaymentResult({
          success: true,
          message: "Multiple payouts initiated successfully",
        });
        // Close all modals and reload data on success
        setTimeout(() => {
          setIsBatchPayments(false);
          reloadData();
          onClose();
        }, 2000);
      } else {
        setPaymentResult({
          success: false,
          message:
            response.message ||
            response.error ||
            "Multiple payouts initiation failed",
        });
      }
    } catch (error: any) {
      setPaymentResult({
        success: false,
        message:
          error?.message || "Payout initiation failed. Please try again.",
      });
    } finally {
      setPaymentLoading(false);
    }
  };

  const onProceedInitiatePayments = async () => {
    if (isItFromHistorySection) {
      await retryPayout();
      return;
    }

    isBatchPyaments ? await makeMultiplePayouts() : await makePayout();
  };

  const resetModalState = () => {
    setRemarks("");
    setCurrentStep("otp");
    setOtp("");
    setSelectedOption("");
    setIsOtpSent(false);
    setPaymentLoading(false);
    setPaymentResult(null);
  };

  const handleCloseAllModals = () => {
    setIsBatchPayments(false);
    setPaymentResult(null);
    onClose();
  };

  const handleCancel = () => {
    resetModalState();
    onClose();
  };

  // Reset state when modal closes
  useEffect(() => {
    if (!open) {
      resetModalState();
    }
  }, [open]);

  return (
    <ThemeProvider theme={theme}>
      <Modal
        open={open}
        onClose={onClose}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
          sx: { backdropFilter: "blur(8px)" },
        }}
      >
        <Fade in={open}>
          <div
            style={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              backgroundColor: "white",
              padding: "30px 40px",
              borderRadius: "30px",
              boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
              maxWidth: "500px",
              width: "100%",
            }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                marginBottom: "20px",
              }}
            >
              <h2
                style={{
                  margin: 0,
                  fontSize: "18px",
                  fontWeight: "600",
                  color: "#333",
                }}
              >
                {currentStep === "otp" && "Sending OTP..."}
                {currentStep === "verify-otp" && "Verify OTP"}
                {currentStep === "face-recognition" && "Face Recognition"}
                {currentStep === "success" && "Payment Initiated Successfully"}
              </h2>
              <IconButton onClick={handleCancel} size="small">
                <CloseIcon />
              </IconButton>
            </div>

            {/* OTP Sending Step */}
            {currentStep === "otp" && (
              <Box style={{ textAlign: "center", padding: "20px" }}>
                <CircularProgress style={{ marginBottom: "20px" }} />
                <Typography variant="body1" style={{ color: "#666" }}>
                  Sending OTP to your registered mobile number...
                </Typography>
              </Box>
            )}

            {/* OTP Verification Step */}
            {currentStep === "verify-otp" && (
              <div>
                <Typography
                  variant="body2"
                  style={{
                    marginBottom: "20px",
                    color: "#666",
                    fontSize: "14px",
                    lineHeight: "1.5",
                  }}
                >
                  Please enter the OTP sent to your registered mobile number.
                </Typography>

                <FormControl fullWidth style={{ marginBottom: "20px" }}>
                  <CustomTextField
                    label="Enter OTP"
                    variant="outlined"
                    value={otp}
                    onChange={(e) => setOtp(e.target.value)}
                    placeholder="Enter 6-digit OTP"
                    inputProps={{ maxLength: 6 }}
                  />

                  {otpErrorMsg && (
                    <Typography
                      variant="body2"
                      style={{
                        color: "red",
                        margin: "5px 0px",
                        fontSize: "12px",
                      }}
                    >
                      {otpErrorMsg}
                    </Typography>
                  )}
                </FormControl>

                <FormControl fullWidth style={{ marginBottom: "20px" }}>
                  <InputLabel id="dropdown-label">Transfer Type</InputLabel>
                  <Select
                    labelId="dropdown-label"
                    value={selectedOption}
                    onChange={(e) => setSelectedOption(e.target.value)}
                    label="Select Option"
                    style={{
                      borderRadius: "10px",
                    }}
                  >
                    {transfterModeOptions?.map((each: any, index: number) => (
                      <MenuItem key={index} value={each?.value}>
                        {each?.label}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>

                <FormControl fullWidth style={{ marginBottom: "20px" }}>
                  <CustomTextField
                    label="Remarks (Optional)"
                    variant="outlined"
                    value={remarks}
                    onChange={(e) => setRemarks(e.target.value)}
                    multiline
                    rows={3}
                    placeholder="Add any additional notes here..."
                  />
                </FormControl>

                <div
                  style={{
                    display: "flex",
                    justifyContent: "flex-end",
                    gap: "10px",
                  }}
                >
                  <Button
                    onClick={handleCancel}
                    variant="outlined"
                    style={{
                      borderColor: "#ddd",
                      color: "#666",
                      textTransform: "none",
                      fontWeight: "500",
                      padding: "10px 20px",
                      borderRadius: "8px",
                    }}
                  >
                    Cancel
                  </Button>
                  <Button
                    onClick={handleVerifyOtp}
                    // onClick={onProceedInitiatePayments}
                    variant="contained"
                    disabled={
                      !otp ||
                      otp.length !== 6 ||
                      Boolean(otpinfo?.is_in_api_call)
                    }
                    style={{
                      backgroundColor: "#007bff",
                      color: "white",
                      textTransform: "none",
                      fontWeight: "500",
                      padding: "10px 20px",
                      borderRadius: "8px",
                      boxShadow: "0 2px 4px rgba(0, 123, 255, 0.3)",
                    }}
                  >
                    Verify OTP
                    {otpinfo?.is_in_api_call && (
                      <CircularProgress
                        style={{
                          marginLeft: "10px",
                          color: "#FFF",
                          height: 20,
                          width: 20,
                        }}
                      />
                    )}
                  </Button>
                </div>
              </div>
            )}

            {/* Face Recognition Step */}
            {currentStep === "face-recognition" && (
              <div style={{ textAlign: "center" }}>
                {/* <Typography
                  variant="h6"
                  style={{
                    margin: "8px 0px",
                    fontSize: "16px",
                    fontWeight: "600",
                  }}
                >
                  Face Recognition
                </Typography> */}

                <Typography
                  variant="body2"
                  style={{
                    margin: "5px 0px 20px",
                    textAlign: "center",
                    fontWeight: 300,
                    opacity: 0.8,
                    color: "#666",
                  }}
                >
                  Please face the camera directly and ensure proper lighting
                </Typography>

                {frError && (
                  <Typography
                    variant="body2"
                    style={{
                      color: "red",
                      margin: "5px 0px",
                      fontSize: "14px",
                    }}
                  >
                    {frError}
                  </Typography>
                )}

                <Button
                  onClick={handleFaceCapture}
                  variant="contained"
                  disabled={Boolean(otpinfo?.is_in_api_call)}
                  style={{
                    marginTop: 20,
                    width: "100%",
                    height: 56,
                    borderRadius: 10,
                    backgroundColor: "#007bff",
                    color: "white",
                    textTransform: "none",
                    fontWeight: "500",
                  }}
                >
                  Capture
                  {frLoading && (
                    <CircularProgress
                      style={{
                        marginLeft: "10px",
                        color: "#FFF",
                        height: 24,
                        width: 24,
                      }}
                    />
                  )}
                </Button>
              </div>
            )}

            {/* Success Step */}
            {currentStep === "success" && (
              <Box style={{ textAlign: "center", padding: "20px" }}>
                <Typography
                  variant="h6"
                  style={{
                    color: "#4caf50",
                    marginBottom: "10px",
                    fontSize: "16px",
                    fontWeight: "600",
                  }}
                >
                  ✓ Verification Complete
                </Typography>
                <Typography variant="body2" style={{ color: "#666" }}>
                  Payment initiation is being processed...
                </Typography>

                {/* {frLoading && ( */}
                <CircularProgress
                  style={{
                    marginLeft: "10px",
                    color: "#FFF",
                    height: 24,
                    width: 24,
                  }}
                />
                {/* )} */}
              </Box>
            )}
          </div>
        </Fade>
      </Modal>

      {/* Payment Loading Modal */}
      <Modal
        open={paymentLoading}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
          sx: { backdropFilter: "blur(8px)" },
        }}
      >
        <Fade in={paymentLoading}>
          <div
            style={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              backgroundColor: "white",
              padding: "40px",
              borderRadius: "20px",
              boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.15)",
              textAlign: "center",
              minWidth: "300px",
            }}
          >
            <CircularProgress
              size={50}
              style={{
                marginBottom: "20px",
                color: "#1976d2",
              }}
            />
            <Typography
              variant="h6"
              style={{
                marginBottom: "10px",
                fontWeight: "600",
                color: "#333",
              }}
            >
              Initiating Payment...
            </Typography>
            <Typography
              variant="body2"
              style={{
                color: "#666",
                fontSize: "14px",
              }}
            >
              Please wait while we process your payment request
            </Typography>
          </div>
        </Fade>
      </Modal>

      {/* Payment Result Modal */}
      <Modal
        open={!!paymentResult}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 3000,
          sx: { backdropFilter: "blur(8px)" },
        }}
      >
        <Fade in={!!paymentResult}>
          <div
            style={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              backgroundColor: "white",
              padding: "40px",
              borderRadius: "20px",
              boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.15)",
              textAlign: "center",
              minWidth: "350px",
              maxWidth: "500px",
            }}
          >
            {paymentResult?.success ? (
              <CheckCircleIcon
                style={{
                  fontSize: "60px",
                  color: "#4caf50",
                  marginBottom: "20px",
                }}
              />
            ) : (
              <ErrorIcon
                style={{
                  fontSize: "60px",
                  color: "#f44336",
                  marginBottom: "20px",
                }}
              />
            )}

            <Typography
              variant="h6"
              style={{
                marginBottom: "15px",
                fontWeight: "600",
                color: paymentResult?.success ? "#4caf50" : "#f44336",
              }}
            >
              {paymentResult?.success
                ? "Payment Initiated successfully!"
                : "Payment Failed"}
            </Typography>

            <Typography
              variant="body1"
              style={{
                color: "#666",
                fontSize: "14px",
                marginBottom: "25px",
                lineHeight: "1.5",
              }}
            >
              {paymentResult?.message}
            </Typography>

            {paymentResult?.success ? (
              <Typography
                variant="body2"
                style={{
                  color: "#999",
                  fontSize: "12px",
                  fontStyle: "italic",
                }}
              >
                This window will close automatically...
              </Typography>
            ) : (
              <Button
                variant="contained"
                onClick={handleCloseAllModals}
                style={{
                  backgroundColor: "#f44336",
                  color: "white",
                  borderRadius: "10px",
                  padding: "10px 30px",
                  textTransform: "none",
                  fontWeight: "600",
                }}
              >
                Close
              </Button>
            )}
          </div>
        </Fade>
      </Modal>
    </ThemeProvider>
  );
};

export default AddDeviceModal;
